<script lang="ts">
	import type { IStats, ICoinInfo } from 'customTypes/coinDetails';
	import AboutCoin from 'components/AboutCoin/AboutCoin.svelte';
	import CoinDescription from 'components/CoinDescription/CoinDescription.svelte';

	export let dark: boolean = false;
	export let stats: IStats;
	export let yearPriceChange: number;
	export let coinsAmount: number;
	export let copywrite;
	export let marketNames: string[];
	export let coinInfo: ICoinInfo;
</script>

<section class="wrapper container" class:dark>
	<div class="text">
		<CoinDescription
			{dark}
			data={stats}
			{yearPriceChange}
			{coinsAmount}
			{copywrite}
			{marketNames}
		/>
	</div>
	<div class="info"><AboutCoin {dark} name={stats.symbol} {coinInfo} /></div>
</section>

<style lang="scss">
	@import 'infoSection';
</style>
